import { connect } from 'react-redux'
import { CartToastComponent } from './CartToastComponent'
import { setCartToast } from 'shared/store/ecommerce/order'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'

const mapStateToProps = (state: RootState) => {
    const { authenticated } = state.userState
    const { isCartToastVisible } = state.ecommerceOrderState
    return {
        authenticated,
        isCartToastVisible
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    setCartToast: (isCartToastVisible: boolean) =>
        d(setCartToast(isCartToastVisible))
})

const CartToast = connect(
    mapStateToProps,
    mapDispatchToProps
)(CartToastComponent)

export { CartToast }
